export default [
  // 分管账号管理
  {
    path: 'account-manage',
    name: 'AccountManage',
    meta: {
      isDynamic: true,
      id: '分管账号管理', // 2
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "AccountManage" */ '@/views/Account/AccountManage/AccountManage.vue'
      )
  },
  // 角色管理
  {
    path: 'role-manage',
    name: 'RoleManage',
    meta: {
      isDynamic: true,
      id: '角色及权限管理', //
      inTab: true
    },
    component: () =>
      import(/* webpackChunkName: "RoleManage" */ '@/views/Account/RoleManage/RoleManage.vue')
  },
  // 业务员账号管理
  {
    path: 'salesman-account-manage',
    name: 'SalesmanAccountManage',
    meta: {
      isDynamic: true,
      id: '业务员账号', // 15
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "SalesmanAccountManage" */ '@/views/Account/SalesmanAccountManage/SalesmanAccountManage.vue'
      )
  },
  // 业务员注册申请查询
  {
    path: 'salesman-register-apply-query',
    name: 'SalesmanRegisterApplyQuery',
    meta: {
      isDynamic: true,
      id: '业务员注册申请查询', // 15
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "SalesmanRegisterApplyQuery" */ '@/views/Account/SalesmanRegisterApplyQuery/SalesmanRegisterApplyQuery.vue'
      )
  },
  {
    path: 'pc-menu-manage',
    name: 'PcMenuManage',
    meta: {
      isDynamic: true,
      id: 'PC菜单管理',
      inTab: true
    },
    component: () => import('@/views/Account/PcMenuManage/PcMenuManage.vue')
  },
  {
    path: 'builtin-role-permission',
    name: 'BuiltinRolePermission',
    meta: {
      isDynamic: true,
      id: '内置角色权限',
      inTab: true
    },
    component: () => import('@/views/Account/BuiltinRolePermission/BuiltinRolePermission.vue')
  }
];
